import React from 'react';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

const TrendIndicator: React.FC<{
    trend: string;
    trendType: 'up' | 'down';
}> = ({ trend, trendType }) => {
    const isUp = trendType === 'up';
    const color = isUp ? 'text-green-500' : 'text-red-500';
    const Icon = isUp ? ArrowUpOutlined : ArrowDownOutlined;

    return (
        <div className={`flex items-center space-x-1 ${color}`}>
            <span className="font-bold text-xs">{trend}</span>
            <Icon className="text-xs" />
        </div>
    );
};

export default TrendIndicator;
